import { combineReducers, configureStore } from '@reduxjs/toolkit';


import { authApi } from '@/features/auth/authApi';
import authSlice from '@/features/auth/authSlice';
import { commercialMeteringPointsApi } from '@/features/commercialMeteringPoints/commercialMeteringPointsApi';
import { contractsApi } from '@/features/contracts/contractsApi';
import { counterpartyAccountsApi } from '@/features/counterpartyAccounts/counterpartyAccountsApi';
import counterpartyAccountsSlice from '@/features/counterpartyAccounts/counterpartyAccountsSlice';
import { counterpartyActualExpensesApi } from '@/features/counterpartyActualExpenses/counterpartyActualExpenses';
import { meteringDeviceIndicatorApi } from '@/features/meteringDeviceIndicator';
import { meteringDeviceStatusApi } from '@/features/meteringDeviceStatus/meteringDeviceStatusApi';
import { meteringDevicesApi } from '@/features/meteringDevices/meteringDevicesApi';
import { organizationsApi } from '@/features/organizations/organizations';
import { reportsApi } from '@/features/reports/reportsApi';
import representativeSlice from '@/features/representatives/representativeSlice';
import { representativesApi } from '@/features/representatives/representativesApi';
import uiSlice from '@/features/ui/uiSlice';

const rootReducer = combineReducers({
  [uiSlice.name]: uiSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [counterpartyAccountsApi.reducerPath]: counterpartyAccountsApi.reducer,
  [counterpartyAccountsSlice.name]: counterpartyAccountsSlice.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [representativesApi.reducerPath]: representativesApi.reducer,
  [representativeSlice.reducerPath]: representativeSlice.reducer,
  [commercialMeteringPointsApi.reducerPath]:
    commercialMeteringPointsApi.reducer,
  [meteringDeviceIndicatorApi.reducerPath]: meteringDeviceIndicatorApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [meteringDeviceStatusApi.reducerPath]: meteringDeviceStatusApi.reducer,
  [counterpartyActualExpensesApi.reducerPath]:
    counterpartyActualExpensesApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [meteringDevicesApi.reducerPath]: meteringDevicesApi.reducer,
});

const middlewares = [
  authApi.middleware,
  counterpartyAccountsApi.middleware,
  contractsApi.middleware,
  representativesApi.middleware,
  commercialMeteringPointsApi.middleware,
  meteringDeviceIndicatorApi.middleware,
  reportsApi.middleware,
  meteringDeviceStatusApi.middleware,
  counterpartyActualExpensesApi.middleware,
  organizationsApi.middleware,
  meteringDevicesApi.middleware,
];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewares),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
